<template>
</template>

<script>
export default {
  mounted() {
    this.$router.replace({name: 'Login'});
    this.$store.dispatch('logout');
  }
}
</script>